import BaseService from './BaseService';

class SettingsService extends BaseService {
  /**
   * Fetch
   * @return {Promise}
   */
  fetch = () => {
    const config = {
      url: '/settings',
    };
    return this.doRequest(config);
  };


  /**
   * Save message preferences
   * @param  {Object} messagePreferences
   * @return {Promise}
   */
  saveMessagePreferences = (messagePreferences = {}) => {
    const config = {
      method: 'post',
      url: '/settings/messagesettings',
      data: {
        ...messagePreferences,
      },
    };
    return this.doRequest(config);
  };


  /**
   * Request password reset
   * @param {String} emailAddress
   * @return {Promise}
   */
  requestPasswordReset = (emailAddress) => {
    const config = {
      method: 'post',
      url: '/settings/requestpasswordreset',
      data: {
        emailAddress,
      },
    };
    return this.doRequest(config);
  };


  /**
   * Reset Password
   * @param {Promise} data
   */
  resetPassword = (data) => {
    const config = {
      data,
      method: 'post',
      url: 'settings/resetpassword',
    };
    return this.doRequest(config);
  };


  /**
   * Change username
   * @param  {String} username
   * @return {Promise}
   */
  changeUsername = (username) => {
    const config = {
      method: 'post',
      url: `/settings/username/${username}`,
    };
    return this.doRequest(config);
  };


  /**
   * Messages via
   * @param  {String} type
   * @return {Promise}
   */
  messagesVia = (type) => {
    const config = {
      method: 'post',
      url: `/settings/messagevia/${type}`,
    };
    return this.doRequest(config);
  };


  /**
   * Deactive account
   * @return {Promise}
   */
  deactivateAccount = () => {
    const config = {
      method: 'post',
      url: '/settings/deactivate',
    };
    return this.doRequest(config);
  };


  /**
   * Link Email to Account
   * @param  {Object} data
   * @return {Promise}
   */
  linkEmailToAccount = (data) => {
    const config = {
      method: 'post',
      url: '/settings/linkemail',
      data: {
        emailAddress: data.emailAddress,
        password: data.password,
      },
    };
    return this.doRequest(config);
  };


  /**
   * Update email address
   * @param  {String} emailAddress
   * @return {Promise}
   */
  updateEmailAddress = (emailAddress) => {
    const config = {
      method: 'post',
      url: '/settings/updateemail',
      data: {
        emailAddress,
      },
    };
    return this.doRequest(config);
  };


  /**
   * unlink Twitter
   * @return {Promise}
   */
  unlinkTwitter = () => {
    const config = {
      method: 'post',
      url: '/settings/unlinktwitter',
    };
    return this.doRequest(config);
  };


  /**
   * unlink Facebook
   * @return {Promise}
   */
  unlinkFacebook = () => {
    const config = {
      method: 'post',
      url: '/settings/unlinkfacebook',
    };
    return this.doRequest(config);
  };


  /**
   * Facebook Login
   * @param  {Object} data
   * @return {Promise}
   */
  linkFacebook = (data) => {
    const config = {
      url: '/facebook/link',
      data,
      method: 'post',
    };
    return this.doRequest(config);
  };
}

export { SettingsService as default };